import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { Outlet } from 'react-router-dom';
import { X } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';

const NextPatientSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="flex lg:flex-row flex-col relative h-[calc(100vh-86px)] overflow-y-auto bg-gray-50">
      <div className="w-[400px] lg:block hidden min-h-[300px] bg-white p-4">
        <div className="flex items-center gap-2 p-2">
          <HomeOutlinedIcon className="text-gray-400" />
          <span className="font-bold text-black text-xl">Start</span>
        </div>

        <div className="flex items-center gap-2 p-2 mt-2 rounded-lg bg-[#eaf1f1]">
          <AssignmentOutlinedIcon className="text-teal-800" />
          <span className="font-bold text-black text-xl">Administratie</span>
        </div>
      </div>

      {isOpen && (
        <div className="lg:hidden w-[320px] slideInLeft z-40 absolute h-full bg-white p-4 border-r-2 ">
          <div className="flex items-center justify-end w-full mb-3">
            <button onClick={() => setIsOpen(false)}>
              <X size={24} />
            </button>
          </div>

          <div className="flex items-center gap-2 p-2">
            <HomeOutlinedIcon className="text-gray-400" />
            <span className="font-bold text-black text-lg">Start</span>
          </div>

          <div className="flex items-center gap-2 p-2 mt-2 rounded-lg bg-[#eaf1f1]">
            <AssignmentOutlinedIcon className="text-teal-800" />
            <span className="font-bold text-black text-lg">Administratie</span>
          </div>
        </div>
      )}

      <div className="lg:hidden px-4 py-2">
        <button onClick={() => setIsOpen(true)}>
          <MenuIcon size={24} />
        </button>
      </div>

      <div className="h-full w-full lg:max-w-[calc(100%-400px)] overflow-y-auto  p-4">
        <div className="h-fit w-full  flex flex-col gap-2.5 bg-white rounded-xl p-2 md:p-8 ">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default NextPatientSidebar;
